__webpack_require__.p = "/dev/884-vuejs-3-pour-le-web-component/";